import { render, staticRenderFns } from "./SpecialistSelect.vue?vue&type=template&id=e948d7ba&scoped=true&"
import script from "./SpecialistSelect.vue?vue&type=script&lang=js&"
export * from "./SpecialistSelect.vue?vue&type=script&lang=js&"
import style0 from "./SpecialistSelect.vue?vue&type=style&index=0&id=e948d7ba&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e948d7ba",
  null
  
)

export default component.exports